import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import { useGetUserQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'WorkspaceMoved',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $auth = _useNuxtApp.$auth,
      $i18n = _useNuxtApp.$i18n;
    var _useGetUserQuery = useGetUserQuery(computed(function () {
        return {
          enabled: $auth.loggedIn
        };
      })),
      userResult = _useGetUserQuery.result,
      onGetUserResult = _useGetUserQuery.onResult;

    // The nav (which normally sets the locale) is hidden on this screen.
    onGetUserResult(function (_ref) {
      var _data$getUser;
      var data = _ref.data;
      if (data !== null && data !== void 0 && (_data$getUser = data.getUser) !== null && _data$getUser !== void 0 && _data$getUser.locale) {
        $i18n.setLocale(data.getUser.locale);
      }
    });
    var hostOf = function hostOf(url) {
      try {
        return new URL(url).host;
      } catch (_unused) {
        return url;
      }
    };

    // One entry per new address, naming the user's workspaces that moved there.
    var destinations = computed(function () {
      var _userResult$value;
      var namesByUrl = new Map();
      var _iterator = _createForOfIteratorHelper(((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : _userResult$value.getUser.accounts) || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var account = _step.value;
          // An account both licensees copied lists both addresses.
          var _iterator2 = _createForOfIteratorHelper(account.movedToUrls),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var url = _step2.value;
              namesByUrl.set(url, [].concat(_toConsumableArray(namesByUrl.get(url) || []), [account.name]));
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _toConsumableArray(namesByUrl.entries()).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          url = _ref3[0],
          names = _ref3[1];
        return {
          url: url,
          host: hostOf(url),
          names: names.sort(function (a, b) {
            return a.localeCompare(b);
          }).join(', ')
        };
      }).sort(function (a, b) {
        return a.host.localeCompare(b.host);
      });
    });
    return {
      __sfc: true,
      $auth: $auth,
      $i18n: $i18n,
      userResult: userResult,
      onGetUserResult: onGetUserResult,
      hostOf: hostOf,
      destinations: destinations
    };
  }
});